export default {
  props: {
    selectedCalls: {
      type: Array,
      default() {
        return [];
      }
    },

    showLoader: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      callsReviewed: false,  
      bulkCallReviewKey: 0,
    };
  },
  methods: {
    hideBulkForm() {
      this.$emit('close');
    },
    
    unselectCallOnBulkAction(call) {
      this.$emit('unselectCallOnBulkAction', call);
      this.bulkCallReviewKey += 1;
    }
  },
};